import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipComponent } from '@iw/common';
import { ThemeService } from '@iw/core/services';

import { AccountWithAmountItem } from '../..';

@Component({
  selector: 'iw-currency-item',
  imports: [IconModule, TooltipComponent, TranslateModule],
  templateUrl: './currency-item.component.html',
  styleUrl: './currency-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.selected]': 'selected()',
  },
})
export class CurrencyItemComponent {
  account = input.required<AccountWithAmountItem>();
  selected = input(false, { transform: booleanAttribute });
  useThemeImage = input(false, { transform: booleanAttribute });
  readonly themeService = inject(ThemeService);

  walletImgSrc = computed(() => {
    const isDark = this.themeService.isDarkTheme();
    const theme =
      (this.selected() || this.useThemeImage()) && !isDark ? 'light' : 'dark';
    return `/assets/images/wallet-${theme}.png`;
  });
}
